import { useState, useEffect } from "react";

const CountDownTwo = () => {
    const [countdownDate] = useState(new Date('10/01/2025').getTime());
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        setInterval(() => setNewTime(), 1000);
    });

    const setNewTime = () => {
        if (countdownDate) {
        const currentTime = new Date().getTime();

        const distanceToDate = countdownDate - currentTime;

        let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
            (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        let minutes = Math.floor(
            (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
        );
        let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

        const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

        days = `${days}`;
        if (numbersToAddZeroTo.includes(hours)) {
            hours = `0${hours}`;
        } else if (numbersToAddZeroTo.includes(minutes)) {
            minutes = `0${minutes}`;
        } else if (numbersToAddZeroTo.includes(seconds)) {
            seconds = `0${seconds}`;
        }

        setState({ days: days, hours: hours, minutes, seconds });
        }
    };

    return (
        <ul className="coming-countdown">
            <li>
                <h4 className="count-title"><span className="days">{state.days || '0'}</span></h4>
                <p className="days_text">days</p>
            </li>
            <li>
                <h4 className="count-title"><span className="hours">{state.hours || '00'}</span></h4>
                <p className="hours_text">Hours</p>
            </li>
            <li>
                <h4 className="count-title"><span className="minutes">{state.minutes || '00'}</span></h4>
                <p className="minu_text">Minutes</p>
            </li>
            <li>
                <h4 className="count-title"><span className="seconds">{state.seconds || '00'}</span></h4>
                <p className="seco_text">Secounds</p>
            </li>
        </ul>
    );
};



export default CountDownTwo;
